import { render, staticRenderFns } from "./TransportDocumentsFormBlock.vue?vue&type=template&id=1bf924ea"
import script from "./TransportDocumentsFormBlock.vue?vue&type=script&lang=js"
export * from "./TransportDocumentsFormBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports